import React from "react"
import IcomoonIcon from "../../shared/IcomoonIcon"
import { breakpoints, color } from "../../../utils/style"
import Img from "gatsby-image"
import PopupIframe, { invokePopup } from "../../shared/PopupIframe"
import styled from "@emotion/styled"
import { Link } from "gatsby"
import GetWindowWidth from "../../shared/GetWindowWidth"

const HowToPlayWrap = styled("div")`
  .wrapper {
    display: flex;
    flex-flow: row wrap;
    margin-bottom: 40px;
    .col {
      flex-basis: 50%;
    }
  }
  @media (max-width: ${breakpoints.md}) {
    .wrapper {
      .col {
        flex-basis: 100%;
      }
      .col-right {
        padding-top: 24px;
      }
    }
  }
`

const HowToPlayVideo = styled("div")`
  background: ${color.darkRed};
  // height: 98.5%;
  margin-left: 60px;
  position: relative;
  .gatsby-image-wrapper {
    filter: brightness(0.6);
  }
  .play-button {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 0;
    right: 0;
    margin: -45px auto 0;
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
    span {
      display: inline-block;
      width: 1px;
      text-indent: -9999px;
    }
    &:hover,
    &:active {
      svg {
        path {
          fill: ${color.brightRed} !important;
        }
      }
    }
  }
  @media (max-width: ${breakpoints.md}) {
    margin-left: 0;
    .terms-button,
    .play-button {
      visibility: visible;
    }
    .play-button {
      top: 38%;
    }
  }
`

const HowToPlay = ({ how_to_play_text, iframe, video_cover }) => {
  const windowWidth = GetWindowWidth()
  const isScrolling = windowWidth > 960

  const videoClick = (e, iframeSrc) => {
    const homeVideoIframe = document.getElementById("free-spin-home-iframe")
    homeVideoIframe.src = iframeSrc
    invokePopup(e, "free-spin-home-popup")
  }

  return (
    <HowToPlayWrap>
      <h2 className="h1 rich-design">
        <span>วิธีเล่นเกมคาสิโนใน SCR888</span>
      </h2>
      <div className="decorative-line" />
      <div className="wrapper">
        <div className="col">
          {how_to_play_text && (
            <p className="description">{isScrolling ? how_to_play_text.slice(0, 1600) + "..." : how_to_play_text}</p>
          )}
          <div className="button-group">
            <Link to="/918kiss-download/" className="button pink-button">ดาวน์โหลด</Link>
            <a href="/register/?register_type=onsitegames" className="button white-button">ลงชื่อเข้าใช้</a>
          </div>
        </div>
        <div className="col col-right">
          <HowToPlayVideo>
            {iframe && (
              <button
                className="play-button"
                onClick={e => videoClick(e, iframe)}
              >
                <IcomoonIcon icon="youtube" color={color.lightRed} size={90} />
                <span>Play</span>
              </button>
            )}
            {video_cover &&
            video_cover.alt_text &&
            video_cover.localFile &&
            video_cover.localFile.childImageSharp && (
              <Img
                fluid={video_cover.localFile.childImageSharp.fluid}
                alt={video_cover.alt_text}
                fadeIn={false}
                loading="eager"
              />
            )}
          </HowToPlayVideo>
        </div>
      </div>
      {iframe && (
        <PopupIframe
          title="Tow to play"
          popupId="how-to-play-home-popup"
          extraClass="wide"
        >
          <div className="iframe-container">
            <iframe
              id="how-to-play-home-iframe"
              title="How to play"
              src="about:blank"
            />
          </div>
        </PopupIframe>
      )}
    </HowToPlayWrap>
  )
}

export default HowToPlay
